import React, { FC } from "react";
import { Icon } from "@shared/components";
import { IconType } from "@shared/components/Icon/Icon";

import "./index.scss";

interface EmptyStateProps {
  title: string;
  icon?: IconType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subtitle?: any;
  component?: React.ReactNode;
}

const EmptyState: FC<EmptyStateProps> = (props) => {
  const { title, subtitle, component, icon = "empty-screen" } = props;
  return (
    <div className="empty-state-wrapper">
      <Icon type={icon} />
      <div className="empty-state-title">{title}</div>
      <div className="empty-state-subtitle">{subtitle}</div>
      {component}
    </div>
  );
};

export default EmptyState;
